import {Layout, TextInput} from '@smart/react-components';
import React, {useContext} from 'react';
import type {DateSchema, StringSchema} from 'yup';
import type {Maybe} from '../../../graphql';
import {FieldContext} from './field-wrapper';
import {parseFieldErrors} from './helpers';
import type {ICommonFieldProps, IWrapperProvider} from './types';
import {useFieldSetup} from './use-field-setup';

type TextInputProps = React.ComponentProps<typeof TextInput>;

interface IProps extends ICommonFieldProps {
  initial?: string;
  props?: Partial<TextInputProps>;
  schema?: StringSchema<any> | DateSchema<any>;
  mask?: (inputString: string, prevString: string) => string;
  label?: Maybe<string>;
}

const TextField = function ({
  tag,
  initial = ``,
  required,
  props,
  schema,
  mask,
  label,
}: IProps) {
  const {getLabel, genericHandler, disabled, state, errors, showErrors} =
    useContext<IWrapperProvider>(FieldContext as any);

  useFieldSetup(tag, initial, schema);

  const [isInvalid, errorMessage] = parseFieldErrors(tag, errors, showErrors);

  return tag in state ? (
    <Layout asChild margin={{bottom: 200}}>
      <TextInput
        name={tag as string}
        children={null}
        id={tag as string}
        label={getLabel(tag, required, label)}
        onChange={(event) => {
          genericHandler(
            tag,
            mask
              ? mask(event.target.value, state[tag] as string)
              : event.target.value,
          );
        }}
        value={state[tag] as string}
        invalid={isInvalid}
        error={errorMessage}
        disabled={disabled}
        {...props}
      />
    </Layout>
  ) : null;
};

export default TextField;
